import React from 'react';
import PropTypes from 'prop-types';

import LoadingState from './LoadingState';
import AuthNotSetup from './AuthNotSetup';
import AuthDetail from './AuthDetail';

const CaregiverAuth = (props) => {
  const {caregiverAuth, openDialogs} = props;

  return (
    <>
      {
        caregiverAuth === undefined &&
        <LoadingState />
      }
      {
        caregiverAuth?.user === null &&
        <AuthNotSetup
          onClick={openDialogs.addAuth}
        />
      }
      {
        !!caregiverAuth?.user &&
        <AuthDetail
          caregiverAuth={caregiverAuth}
          removeAuth={openDialogs.removeAuth}
          resetPassword={openDialogs.resetPassword}
          reactivateAuth={openDialogs.reactivateAuth}
        />
      }
    </>
  );
};

CaregiverAuth.propTypes = {
  caregiverAuth: PropTypes.object,
  openDialogs: PropTypes.object.isRequired,
};

export default React.memo(CaregiverAuth);
